import http from "./http";

export const fetchModelsByBrand = async (payload) => {
    const res = await http.post("/models/by-brand", payload, {
        skipGlobalLoader: true
    });
    return res.data;
};

export const attachModelToBrand = async (payload) => {
    const res = await http.post("/models/attach/brand", payload, {
        skipGlobalLoader: true
    });
    return res.data;
};

export async function deleteModel({ brandId, modelId }) {
    const res = await fetch(process.env.REACT_APP_BACKEND_BASE_URL + "/api/v1/models/delete", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-source-system": "web",
        },
        body: JSON.stringify({
            brandId,
            modelId,
        }),
    });

    if (!res.ok) {
        let message = "Failed to delete model";
        try {
            const err = await res.json();
            message = err.message || message;
        } catch {
            // ignore parse error
        }
        throw new Error(message);
    }

    try {
        return await res.json();
    } catch {
        return { message: "Model deleted successfully" };
    }
};

export async function updateModel({ modelId, name }) {
    const res = await fetch(process.env.REACT_APP_BACKEND_BASE_URL + "/api/v1/models/update", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "x-source-system": "web",
        },
        body: JSON.stringify({
            modelId,
            name,
        }),
    });

    if (!res.ok) {
        let message = "Failed to update model";
        try {
            const err = await res.json();
            message = err.message || message;
        } catch {
            // ignore parse error
        }
        throw new Error(message);
    }

    try {
        return await res.json();
    } catch {
        return { message: "Model updated successfully" };
    }
}
